import {
  createSiteAllowlistFlag,
  createSiteAllowlistFlagFromVar,
} from "@/utils/siteAllowlistFlag";

// One var: "true" enables everywhere (staging/dev), otherwise a
// comma-separated site-id allowlist (prod, FOG-2510). Staff gating lives at
// call sites; deliberately not in the dynamic-FF registry.
const siteAllowlistCheck = createSiteAllowlistFlagFromVar(
  import.meta.env.VITE_FF_MARKETING_CALENDAR_SITES,
);

export const isMarketingCalendarEnabledForSite = (
  siteId: string | undefined,
): boolean => siteAllowlistCheck(siteId);

/** NOT reactive — env-only plain alias since the dynamic override left.
 * If a runtime-toggleable input ever returns, make this a real hook again. */
export const useIsMarketingCalendarEnabledForSite =
  isMarketingCalendarEnabledForSite;

// Dev-only calendar tooling (FOG-2271): the Generate Blastro Campaign
// button, which creates real agent-sourced campaigns. Never on in prod.
const devToolsCheck = createSiteAllowlistFlag(
  import.meta.env.VITE_FF_MARKETING_CALENDAR_DEV_TOOLS,
  import.meta.env.VITE_FF_MARKETING_CALENDAR_DEV_TOOLS_SITES,
);

export const isMarketingCalendarDevToolsEnabledForSite = (
  siteId: string | undefined,
): boolean => devToolsCheck(siteId);

// Campaign offer override (FOG-2459, CON-312): "true" or a site-id CSV. Turn
// a site on only once senderer + optins-backend resolve overrides in prod.
const offerOverrideCheck = createSiteAllowlistFlagFromVar(
  import.meta.env.VITE_FF_MARKETING_CALENDAR_OFFER_OVERRIDE_SITES,
);

export const isOfferOverrideEnabledForSite = (
  siteId: string | undefined,
): boolean => offerOverrideCheck(siteId);
